<template>
  <div class="scienceActive">
    <div class="presentationActivity">
      <PresentationBox
        :presentationData="item"
        v-for="item in presentationList"
        :key="item.id"
      />
    </div>
  </div>
</template>
<script>
import PresentationBox from "../components/presentationBox.vue";
export default {
  name: "scienceActive",
  components: {
    PresentationBox,
  },
  data() {
    return {
      presentationList: [],
      lan: this.$store.state.isEn,
    };
  },
  watch: {
    "$store.state.isEn"() {
      this.lan = this.$store.state.isEn;
    },
  },
  mounted() {
    this.init();
  },

  methods: {
    async init() {
      await this.$api.get(
        "/activity/list",
        { current: 1, pageSize: 10, activityType: 2 },
        (r) => {
          const { data = {}, code } = r;
          if (code == 0) {
            this.presentationList = data;
          }
        }
      );
    },
  },
};
</script>

<style scoped>
.scienceActive {
  margin: 0 auto;
  margin-top: 7%;
  width: 1450px;
}
.presentationActivity {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-between;
}
@media (max-width: 1440px) {
  .scienceActive {
    margin: 100px auto 30px;
    width: 90%;
  }
  .presentationActivity {
    transform: scaleX(0.9);
    justify-content: space-evenly;
  }
}
@media (max-width: 960px) {
  .presentationActivity {
    transform: scaleX(1);
    justify-content: space-between;
  }
  .scienceActive {
    margin: 100px auto 30px;
    width: 99%;
  }
}
</style>
